// import React, { useState } from "react";
// import { Document, Page } from "react-pdf";
// import pdf from "../docs/Resume.pdf";
// const Resume = () => {
//   const [numPages, setNumPages] = useState(null);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   return (
//     <div className="flex flex-row justify-center items-center">
//       <Document
//         file={pdf}
//         options={{ workerSrc: "/pdf.worker.js" }}
//         onLoadSuccess={onDocumentLoadSuccess}
//       >
//         {Array.from(new Array(numPages), (el, index) => (
//           <Page key={`page_${index + 1}`} pageNumber={index + 1} />
//         ))}
//       </Document>

//       <div className="absolute lg:bottom-10 lg:right-10 bottom-5 right-5 ">
//         <span className="text-lg p-1 px-3 rounded-lg bg-myRed flex justify-center items-center  hover:bg-myRed hover:bg-opacity-70 text-white cursor-pointer">
//           Download
//         </span>
//       </div>
//     </div>
//   );
// };

// export default Resume;

import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdf from "../docs/Resume.pdf";

const Resume = () => {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  console.log(numPages);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }
  return (
    <>
      <div className=" w-screen h-screen overflow-y-auto resume">
        <div className="flex flex-row justify-center items-center pt-5">
          <Document
            file={pdf}
            onLoadSuccess={onDocumentLoadSuccess}
            className="max-w-full"
          >
            <Page pageNumber={pageNumber} />
          </Document>
        </div>
        <a href={pdf} download="Muiz Ogundiran Resume.pdf">
          <span className="absolute bottom-5 right-5 text-lg p-1 px-3 rounded-lg bg-myRed flex justify-center items-center  hover:bg-myRed hover:bg-opacity-70 text-white cursor-pointer">
            Download
          </span>
        </a>
      </div>
    </>
  );
};

export default Resume;
